import React, { useState } from "react";
import TrackLimoLogo from "../../assets/tracklimo-logo.svg";
import { useDispatch, useSelector } from "react-redux";
import { setError } from "../../redux/auth/auth-slice";
import { sync } from "framer-motion";
import axios from "axios";
import { toast } from "react-toastify";
import Footer from "../../components/footer/Footer";
// import { useNavigate } from "react-router-dom";
import Bg from "../../assets/bg.jpg";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/fontawesome-free-solid";

const ForgotPassword = () => {
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const sendEmail = async () => {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/affiliates/forgotPassword`,
      { email: email }
    );
    console.log(response);
    console.log(response?.response?.status);

    if (response.data.success) {
      // alert("Email sent successfully. Check your mail for further process.");
      toast.success(
        "Email sent successfully. Check your mail for further process."
      );
    } else {
      // console.log("calling");
      toast.error("Email not found");
    }
  };

  // selectors
  const [errorMessage, setErrorMessage] = useState("");

  const { errmsg, isLoggedin } = useSelector((state) => state.auth);

  // states
  const [loginInputField, setloginInputField] = useState({
    username: "",
  });

  const handleSubmit = (e) => {
    setErrorMessage("Username Required");
  };

  return (
    <div className="relative">
      <div className="h-screen w-screen absolute">
        <div className="bg-black opacity-90 absolute w-full h-full"></div>
        <img src={Bg} alt="" className="h-full w-full object-cover" />
      </div>

      <div className="space-y-5 sm:space-y-10 relative px-2">
        <Link to="/">
          <div className="flex space-x-2 justify-start mx-5 xs:mx-5 sm:mx-16 md:mx-32">
            <img
              src={TrackLimoLogo}
              alt="Tracklimo Logo"
              className="w-48 h-32 sm:w-52 sm:h-24 md:w-60 md:h-32"
            />
          </div>
        </Link>

        <div className="mt-6 px-5 sm:px-10 xl:px-16 2xl:px-32 w-min text-white">
          <Link
            to="/login"
            className="bg-slate-900 border border-slate-800 rounded-full p-2"
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="w-5 h-5 text-white/800 cursor-pointer pt-0.5"
            />
          </Link>
        </div>

        <div className="flex justify-center mx-5 sm:mx-0 md:mx-40">
          <div className="relative">
            <div className="w-60 sm:w-80 h-60 sm:h-80 rounded-full bg-gradient-to-b from-[#190061] to-[#0A1B30] absolute -top-10 sm:-top-20 -left-20 md:-top-14 md:-left-32 lg:-left-16 xl:-left-32"></div>
            {/* <div className="w-60 sm:w-80 h-60 sm:h-80 rounded-full bg-gradient-to-b from-[#041248] to-[#0A1B30] absolute -right-6 -bottom-10 sm:-bottom-16 sm:right-10 md:-bottom-12 md:-right-16 lg:-right-6 lg:-bottom-6 xl:-right-16 xl:-bottom-12"></div> */}
          </div>
          <div
            className={`backdrop-blur-md ${
              errmsg ? " border-red-900 " : "bg-slate-800/5"
            }   border border-white/30 w-full xs:w-[26.25rem] xl:w-[30rem] h-72 rounded-2xl pt-5 sm:pt-10 shadow-[rgba(0,0,15,0.5)_0px_5px_4px_10px] `}
          >
            <div className="text-3xl sm:text-4xl px-6 sm:px-10 text-left text-gray-200 font-semibold">
              <h2>Forgot Password</h2>
              <div className="text-base font-normal mt-1">
                Please enter your email!
              </div>
            </div>

            <div className="px-6 sm:px-10 pt-7 space-y-3.5 h-96">
              <InputField
                // label="Email Address"
                type="email"
                name="email"
                placeholder="example@gmail.com"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <div className="space-y-2">
                {!errorMessage && <p className="error"> {errorMessage} </p>}
                {!isLoggedin ? (
                  <div
                    onClick={sendEmail}
                    className="w-full flex justify-center cursor-pointer bg-gradient-to-r py-2.5  from-[#2f4def] to-[#0110a6] text-2xl font-medium rounded-md text-white"
                  >
                    Send
                  </div>
                ) : (
                  <div className="w-full flex justify-center  cursor-pointer bg-gradient-to-b py-1  from-teal-600 to-teal-800 hover:bg-gradient-to-t text-lg font-medium rounded-md text-white">
                    <div class="flex items-center justify-center">
                      <div
                        class="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                        role="status"
                      >
                        <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                          Loading...
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="px-10"><Footer /></div> */}
      </div>
    </div>
  );
};

export default ForgotPassword;

const InputField = ({ label, type, onChange, placeholder }) => {
  return (
    <>
      <div className="space-y-0.25">
        <div className="text-lg text-gray-200 font-semibold ">{label}</div>
        <input
          onChange={onChange}
          type={type}
          placeholder={placeholder}
          className="bg-transparent border rounded-md w-full px-2 py-2.5 target:bg-transparent focus:outline-none focus:border-blue-600 text-gray-400 text-sm font-normal"
        />
      </div>
    </>
  );
};
